import { Plus } from 'lucide-react';
import { Button } from '@ideoz/ui';

interface FilesHeaderProps {
  description: string;
  onUpload: () => void;
}

/** Dumb: title + description + the primary upload button. */
export function FilesHeader({ description, onUpload }: FilesHeaderProps): JSX.Element {
  return (
    <header className="mb-6 flex items-start justify-between gap-4">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Files</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{description}</p>
      </div>
      <Button onClick={onUpload} className="gap-1.5">
        <Plus className="w-4 h-4" />
        Upload files
      </Button>
    </header>
  );
}
